/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { string } from 'prop-types';

const SearchIcon = ({ fillColor }) => (
    <svg width="24" height="24" viewBox="0 0 28 28" fill="none">
        <path
            d="M24.7185 23.4352L17.6939 16.4106C18.8285 14.9975 19.5078 13.2031 19.5078 11.25C19.5078 6.69389 15.8139 3 11.2578 3C6.70171 3 3.00781 6.69389 3.00781 11.25C3.00781 15.8061 6.70171 19.5 11.2578 19.5C13.2003 19.5 14.9857 18.8282 16.3953 17.7048L23.4221 24.7315C23.78 25.0895 24.3604 25.0895 24.7184 24.7315C25.0765 24.3735 25.0765 23.7931 24.7185 23.4352ZM4.8412 11.25C4.8412 7.70641 7.71431 4.83335 11.2579 4.83335C14.8014 4.83335 17.6746 7.70641 17.6746 11.25C17.6746 13.0269 16.952 14.6352 15.7848 15.7972C15.7847 15.7973 15.7846 15.7974 15.7845 15.7975C15.7845 15.7975 15.7844 15.7976 15.7843 15.7977C14.6239 16.9527 13.0243 17.6667 11.2579 17.6667C7.71431 17.6667 4.8412 14.7936 4.8412 11.25Z"
            fill={fillColor}
        />
    </svg>
);

SearchIcon.propTypes = {
    fillColor: string,
};

SearchIcon.defaultProps = {
    fillColor: '#555555',
};

export default SearchIcon;
